import { computed } from '@ember/object';
import { equal, and } from '@ember/object/computed';
import Em from 'ember';
export default Em.Object.extend({
  itemIndex: 0,
  positionIndex: 0,
  isFirstItem: equal('itemIndex', 0),
  isAtStartOfItem: equal('positionIndex', 0),
  isAtStart: and('isFirstItem', 'isAtStartOfItem'),
  info: computed('itemIndex', 'positionIndex', function () {
    return `${this.itemIndex}:${this.positionIndex}`;
  }),
  copy() {
    return this.constructor.create({
      itemIndex: this.get('itemIndex'),
      positionIndex: this.get('positionIndex')
    });
  }
});